import {createContext} from 'react';

export interface MuteContextType {
    isSoundMuted: boolean | null,
    toggled: boolean,
}

export const MuteVideoContext = createContext<MuteContextType | undefined>(undefined);
